<script lang="ts">
	import DashSelectList from '../Components/DashSelectList.svelte';
	import type { DashWidgetEditType, ListRefType } from '../../dash-types';

	export let allTypeRefs: ListRefType;
	export let editItem: DashWidgetEditType;
	export let energyOnly = false;
</script>

<DashSelectList bind:editItem bind:allCardsRefs={allTypeRefs} {energyOnly} />
